import { ServerNotification } from '../../types/serverNotifications/serverNotificationTypes';

/**
 * Merges a server snapshot with events received while it was loading.
 * @param snapshot Notifications from the HTTP response or current state.
 * @param updates Newer live notifications, keyed by ID.
 * @param resolvedIds Locally or remotely confirmed resolutions.
 * @returns Unique pending notifications, preserving newer live data.
 */
export const mergePendingNotifications = (
    snapshot: ServerNotification[],
    updates: Map<string, ServerNotification>,
    resolvedIds: Set<string>
): ServerNotification[] => {
    const merged = new Map(
        snapshot.map(notification => [notification.id, notification])
    );
    updates.forEach((notification, id) => merged.set(id, notification));
    return [...merged.values()].filter(
        notification =>
            !notification.resolved && !resolvedIds.has(notification.id)
    );
};

/**
 * Removes confirmed resolutions without changing other pending notifications.
 * @param notifications Current pending notifications.
 * @param ids Confirmed notification IDs.
 * @returns The remaining pending notifications.
 */
export const removeResolvedNotifications = (
    notifications: ServerNotification[],
    ids: Set<string>
): ServerNotification[] =>
    notifications.filter(notification => !ids.has(notification.id));
